"use strict";
/**
 * Display-text normalization helpers.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeEncodedAmpersands = decodeEncodedAmpersands;
/**
 * Decodes one or more HTML-encoded ampersands in API text.
 *
 * Some legacy course data has been encoded more than once, for example
 * `&amp;amp;`.  Decode only ampersands—not arbitrary HTML—to preserve the
 * source text while making course names readable in every UI surface.
 */
function decodeEncodedAmpersands(value) {
    if (value == null)
        return undefined;
    let decoded = value;
    while (/&amp;/i.test(decoded)) {
        decoded = decoded.replace(/&amp;/gi, '&');
    }
    return decoded;
}
